import { useEffect, useRef } from 'react';

const useFirstConditionEffect = (condition: boolean, effect: () => void) => {
  const isFirst = useRef(true);

  useEffect(() => {
    if (condition && isFirst.current) {
      effect();
      isFirst.current = false;
    }
  }, [condition]);
}

export default useFirstConditionEffect;